import purchases from "./purchases";
import orders from "./orders";

export default {
    purchases,
    orders
}
